import React from 'react';
import { cn } from '@/components/utils/utils';

interface LoaderProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({ 
  size = 'md', 
  className = ''
}) => {
  const sizeClasses = {
    xs: 'w-4 h-4',
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  return (
    <div className={cn(
      'relative',
      sizeClasses[size],
      className
    )}>
      <div className="absolute inset-0 rounded-full border-2 border-gray-200"></div>
      <div className="absolute inset-0 rounded-full border-2 border-[#222] border-t-transparent animate-spin"></div>
    </div>
  );
};

export default Loader; 